import React from "react";

import ThreadScreen from "@/screens/Messaging/ThreadScreen";

export default function page(): React.JSX.Element {
  return <ThreadScreen />;
}
